'use client';

import useSWRInfinite from 'swr/infinite';
import map from 'lodash/map';
import LoadingIcon from 'components/_other/icons/LoadingIcon';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Link from 'next/link';

const Infinite = ({
  totalCount = 0,
  pageCount = 1,
  currentPage = 0,
  perPage = 0,
  handleGetKey,
  handleGetHref,
  render,
  destinationElementId = null,
  searchData,
  categoryName,
  activePage,
  className,
  loadMoreDescription,
}) => {
  const {
    data,
    size: actualPage,
    setSize: setActualPage,
    isValidating,
  } = useSWRInfinite(handleGetKey, url => fetch(url).then(r => r.json()), {
    initialSize: currentPage > 1 ? currentPage : 1,
    revalidateOnReconnect: false,
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  // const searchParams = useSearchParams();
  // const activePage = searchParams.get('page') || 1;

  const [isBrowser, setIsBrowser] = useState(false);
  const [inUse, setInUse] = useState(false);

  const handleLoadMore = () => {
    const newPage = actualPage ? actualPage + 1 : 2;
    setActualPage(newPage);
    setInUse(true);
    handleGetHref(actualPage);
  };

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  useEffect(() => {
    const newPage = Number(activePage) || 1;
    setActualPage(newPage);
  }, [activePage, currentPage]);

  if (isBrowser) {
    return (
      <>
        {inUse
          ? createPortal(
              map(data, (page, index) => {
                if (index < currentPage) {
                  return;
                }
                return render(page);
              }),
              document.getElementById(destinationElementId),
            )
          : ''}
        {actualPage < pageCount ? (
          <>
            <div className={className}>
              <Link href={'#'} onClick={handleLoadMore}>
                {isValidating ? (
                  <>
                    <LoadingIcon className={'mx-auto'} />
                  </>
                ) : (
                  (loadMoreDescription ?? 'Zobraziť ďalšie produkty')
                )}
              </Link>
            </div>
          </>
        ) : (
          ''
        )}
      </>
    );
  }

  return null;
};

export default Infinite;
